import styled from 'styled-components';
import { IonInput } from '@ionic/react';

export const Root = styled(IonInput)`
  --box-shadow: none;
  --color: ${({ theme }) => theme.palette.brown400};
  --placeholder-color: ${({ theme }) => theme.palette.brown400};
`;
